import * as React from "react";
import { Link } from "react-router-dom";
import { idolSelectData } from "public/data/idol_select";
import "src/styles/idol_select.css"
import { useEffect, useRef, useState } from "react";
import { calculateAnimationDelay } from "src/scripts/utility";
import { PageTitle } from "src/components/pageTitle";
import { IdolFace } from "src/components/spriteWrappers";
import { idolData } from "public/data/idols/idols";

export function IdolSelect(props){
    return <IdolSelectView 
    idols={idolSelectData.idols}
    style={{
        "--img_width": `${idolSelectData.width}px`,
        "--img_height": `${idolSelectData.height}px`
    }}
    />
}

function IdolContainer(props){
    return (<div className="idol-container" 
    style=
        {{
        "--idol_color":`var(--${props.idol}_main)`,
        zIndex: 7 - Math.abs(5 - (props.index + 1)),
        animationDelay: calculateAnimationDelay(props.index, 9),
        gridColumnStart: `start-${props.index+1}`,
        gridColumnEnd: `end-${props.index+1}`
    }}
    >
    <div className="render-container-wrapper">
        <div className="render-container">
            <Link className="image-link" to={`${props.idol}`} prefetch="intent">
                <img className="render" src="images/idols/idol_sprites_small.png" style={{objectPosition: `calc(-${props.index} * var(--img_width)/9)`}}/>
            </Link>
        </div>

    <h5 className="idol-name" style={{color: `var(--${props.idol}_main)`}}>{props.idol.charAt(0).toUpperCase() + props.idol.slice(1)}</h5>
</div>
</div>)
}

function IdolSelectView(props){

    // make sure the user views the article from its start
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    const ref = useRef();
    const [gimmickWidth, setGimmickWidth] = useState(0);
    const gimmickSolution = useRef();
    const [width, setWidth] = useState(0);

    const magic_width_number = 1050 / 0.8;
    var dude_please = 1143;
    var max_shrink = 0.19;
    
    useEffect(() => {

        const getWidth = () => {
            setWidth(ref.current.offsetWidth);
            setGimmickWidth(gimmickSolution.current.offsetWidth);
            document.documentElement.style.setProperty('--div-width', `${width}px`)
            document.documentElement.style.setProperty('--shrink-amount', 
                `${(gimmickWidth === 0 && window.innerWidth <= magic_width_number) ? 
                (-max_shrink / (magic_width_number - dude_please)) * (window.innerWidth - magic_width_number) : 0}
                px`
            );
        };

        getWidth()

        window.addEventListener("resize", getWidth);
        return () => window.removeEventListener("resize", getWidth);
    }, [gimmickWidth, width]);

    return (
    <>
    <PageTitle pageTitle="Idols"/>
    <div className="maindiv2" style={props.style}>
        <div className="white-bg" ref={ref}/>
        <div id="idol-container-container">
            {props.idols.map((idol, index) => {
                return <React.Fragment key={idol}>
                <IdolContainer
                idol={idol}
                index={index}
                />
                </React.Fragment>
            })}
            <div id="gimmick-solution" ref={gimmickSolution}/>
        </div>

        <div id="idol-nav-select">
            {idolData.order
            .map(idol => {
                return <div className="idol-button-wrapper"><Link
                key={idol}
                className="idol-button"
                to={`/idols/${idol}`}
                style={{"--color-main":`var(--${idol}_strong)`, "--color-soft":`var(--${idol}_soft)`}}
                >
                    <IdolFace slug={idol}/>
                    <div className="idol-select-text-logo" style={{"--link":`url(/images/idols/${idol}/logo_main.png)`}}/>
                    {/* <img 
                    className="idol-button-image" 
                    src={`/images/idols/${idol}/face_small.png`} 
                    /> */}
                </Link></div>
            })}
        </div>    
    </div>
    </>)
}